export var gameState: any =
{
    player:
    {
        speed: 0,
        multiplier: 1,
        powerupMultiplier: 1,
        multiplierIncrements: 0.15,
        isControllable: true
    },
    level:
    {
        currentLevel: 0,
        currentStage: 0,
        transitioning: false,
        isOutside: false
    }
};



// WEBPACK FOOTER //
// ./src/ts/game/config/GameState.ts